import { COMPANY_EMAIL, COMPANY_LOCATION, COMPANY_PHONE_TEXT, COMPANY_PHONE_URL } from "../utils/constants";

export const service_Contact_Us_Data = {
   link: "https://www.youtube.com/embed/RXQhzEF8Bq8",
  //image: "/images/services/intro.png",
  title: "ADVANCING SURGICAL EXCELLENCE IN BROAD RANGE OF DISCIPLINES",
  contentTop:
    "Achieving superior patient outcomes while mitigating risks in day-to-day healthcare operations. We take pride in offering surgical training and modern techniques to aspiring surgical and Physician Assistants, empowering them to excel in various surgical specialties, including robotics. Our providers are dedicated to delivering high-quality care, placing patient well-being above all else.",

  contentBottom:
    "Our assistants are fully equipped with the latest surgical technology and techniques to ensure superior outcomes for our patients. Additionally, our cardiothoracic Surgical and Physician Assistant team collaborates with cardiac surgeons who bring over 30 years of experience to their practice, further enhancing the quality of care provided throughout their careers.",
  slope: true,

  //   contactInfo: [
  //     { title: "Find us Here", content1: `${COMPANY_LOCATION}` },
  //     {
  //       title: "Get In touch",
  //       content1: `${COMPANY_PHONE_TEXT[0]}`,
  //       content2: "Email Us",
  //     },
  //     {
  //       title: "Training Hours",
  //       content1: "Mon- Fri: 9am- 8pm",
  //       content2: "Saturday: 10am-4pm",
  //     },
  //   ],
};
export const contactUsData = {
  // link: "https://www.youtube.com/watch?v=K00OivV1MnI",
  image: "/images/contact/intro.png",
  title: "Surgical Assistants in the Greater Houston area and Corpus Christi",
  contentTop: `The staff at Universal Surgical Assistants welcomes your call and looks forward to assisting you.  If you have any questions about our services, please call our office at ${COMPANY_PHONE_TEXT[0]}`,

  contentBottom:
    "Over the past 30 years, we have proudly assisted surgeons at hospitals and ambulatory surgery centers all over the Southeast Texas area – Houston, Sugar Land, Katy, Cypress, Humble, Tomball, Pearland, the Woodlands, Corpus Christi, and more!",
  slope: true,

  contactInfo: [
    { title: "Find us Here", content1: `${COMPANY_LOCATION}` },
    {
      link: true,
      title: "Get In touch",
      content1: `${COMPANY_PHONE_TEXT[0]}`,
      content2: "Email Us",
      link1: COMPANY_PHONE_URL,
      link2: `mailto:${COMPANY_EMAIL}`,
    },
    {
      title: "Training Hours",
      content1: "Mon- Fri: 9am- 8pm",
      content2: "Saturday: 10am-4pm",
    },
  ],
};

export const careerContactUsData = {
  link: "https://www.youtube.com/watch?v=_LO5gCbBdl0",
  title: "The Total Care Philosophy",
  contentTop: `We uphold the ethics of “Total Care Philosophy” which defines pathways to engage with Surgeons for an optimal patient outcome.`,

  contentBottom:
    "We are committed to train passionate Surgical and Physician Assistants to expand our team for a remarkable journey throughout their career.  Our providers enjoy the freedom to focus on patient care while achieving the highest level of patient outcome.",
  slope: true,
};
export const surgicalAssistantContactData = {
  link: "https://www.youtube.com/watch?v=9XyaJCr8-NA",
  title: "COMMITTED TO OPTIMIZE EFFICIENCY & PRODUCTIVITY WHILE IMPROVING PATIENT SAFETY & SURGICAL CARE",
  contentTop:
    "Our expert team of Surgical and Physician Associates plays a vital role in supporting exceptional patient outcomes. By enhancing safety, efficiency, and consistency in the operating room, we empower surgeons with specialized, reliable support—ensuring high-quality care at every step.",
  slope: true,
  intoImgData: "/images/providers/surgicalFrame2.png",
};
export const generalSurgeryData = {
  //link: "https://www.youtube.com/watch?v=9XyaJCr8-NA",
  title: "TEXAS PHYSICANS CONTINUE TO BREAK GROUND AND MEET CHALLANGES IN FIELD OF MEDICINE & SURGERY",
  contentTop:
    "Our program provides comprehensive training across multiple surgical specialties with a proven track record of growth, particularly for recently graduated Physician Associates from accredited PA schools. We take pride in instilling our core values of leadership development, teamwork, lifetime learning, self-motivation, integrity, and reflective practice, all with the primary focus on delivering excellent patient care.",
  slope: true,
  intoImgData: "/images/providers/genralSurgeryFrame.png",
};
export const generalSurgeryDetailData = {
  //link: "https://www.youtube.com/watch?v=9XyaJCr8-NA",
  title: "General surgeons deliver expert, patient-centered care with a focus on safety and optimal outcomes.",
  contentTop:
    "In the U.S., general surgeons perform a wide range of procedures—an average of 23 different types—requiring constant updates in skill and knowledge. Because of this versatility, general surgery sets the standard for surgical care, with each day bringing unique challenges that demand precision and focus from the entire surgical team.",
  slope: true,
  intoImgData: "/images/providers/genralSurgeryFrame.png",
};
export const generalSurgeryDetaillinkData = {
  link: "https://www.youtube.com/watch?v=TRK3J5KsLtw",
  title: "TEXAS PHYSICIANS ENHANCEd THE FIELD OF SURGERY BY ADVANCING MODERN SURGICAL TECHNIQUES",
  contentTop:
    "Our physicians lead a dedicated, multidisciplinary team committed to delivering seamless, patient-centered care. Each provider plays an essential role in ensuring surgical success, minimizing readmissions, and supporting every step of the patient’s recovery journey.",

  slope: true,
};
export const generalSurgeryDetaillinkData2 = {
  intoImgData: "/images/physianDirectory/md1.png",
  title: "GENERAL SURGEON",
  mdcontent:
    "Michael T. Wood, MD, FACS, is a skilled general surgeon at Southwest Surgical Associates. He sees patients from the practice’s office locations in Sugar Land and Houston, Texas.",
  mdname: "MICHAEL T. WOOD, MD, FAC",
};
export const patientResource = {
  link: "https://www.youtube.com/watch?v=TRK3J5KsLtw",
  title: "Surgical Assistants in the Greater Houston area and Corpus Christi",
  contentTop:
    "The staff at Universal Surgical Assistants welcomes your call and looks forward to assisting you.  If you have any questions about our services, please call our office at (832) 655-4141.",
  contentBottom:
    "Over the past 30 years, we have proudly assisted surgeons at hospitals and ambulatory surgery centers all over the Southeast Texas area – Houston, Sugar Land, Katy, Cypress, Humble, Tomball, Pearland, the Woodlands, Corpus Christi, and more!",
  slope: true,
};
export const paresidencytrainingprogram = {
  link: "https://www.youtube.com/watch?v=TRK3J5KsLtw",
  title: "Physician Assistant RESIDENCY",
  title3: "TRAINING PROGRAM",
  contentBottom:
    "Our Physician Assistant Residency Training Program is designed to equip newly graduated PAs with comprehensive, hands-on experience across multiple surgical specialties. Our team provides a complete solution to the diverse needs of surgeons in Texas hospitals and surgery centers, combining advanced clinical training with mentorship, leadership development, and a focus on delivering exceptional patient care.",
  slope: true,
};
